module.exports = __webpack_public_path__ + "img/div-02.9da24165.png";